module.exports = __webpack_public_path__ + "static/media/item-tags.a75d95d0.png";